import { render, staticRenderFns } from "./NewTasksCard.vue?vue&type=template&id=878449e6&scoped=true"
import script from "./NewTasksCard.vue?vue&type=script&lang=ts"
export * from "./NewTasksCard.vue?vue&type=script&lang=ts"
import style0 from "./NewTasksCard.vue?vue&type=style&index=0&id=878449e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878449e6",
  null
  
)

export default component.exports